import Section from './ui/Section';
import Reveal from './ui/Reveal';
import elastic from '../assets/img/elastic.svg';
import statamic from '../assets/img/statamic.svg';
import nodejs from '../assets/img/nodejs.svg';
import laravel from '../assets/img/laravel.svg';
import aws from '../assets/img/aws.svg';
import php from '../assets/img/php.svg';
import javascript from '../assets/img/javascript.svg';
import webpack from '../assets/img/webpack.svg';
import react from '../assets/img/react.svg';
import shopify from '../assets/img/shopify.svg';

const SKILLS = [
  { src: elastic, alt: 'Elasticsearch' },
  { src: statamic, alt: 'Statamic' },
  { src: nodejs, alt: 'Node.js' },
  { src: laravel, alt: 'Laravel' },
  { src: aws, alt: 'AWS' },
  { src: php, alt: 'PHP' },
  { src: javascript, alt: 'JavaScript' },
  { src: webpack, alt: 'Webpack' },
  { src: react, alt: 'React' },
  { src: shopify, alt: 'Shopify' },
];

export default function Skills() {
  return (
    <Section id="skills" heading="Skills" index="04">
      {/* Borderless, monochrome (uniform white) logo grid; each lights up in its real
          brand color on hover. Generous spacing, no boxes — floats on the page background. */}
      <div className="grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-3 lg:grid-cols-5">
        {SKILLS.map((s, i) => (
          <Reveal key={s.alt} delay={(i % 5) * 0.05} className="group flex items-center justify-center py-3">
            <img
              src={s.src}
              alt={s.alt}
              loading="lazy"
              decoding="async"
              className="h-8 w-auto max-w-[150px] object-contain opacity-50 brightness-0 invert motion-safe:transition motion-safe:duration-300 group-hover:opacity-100 group-hover:brightness-100 group-hover:invert-0 lg:h-9"
            />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
